import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export const PANEL_ID = 'social-accounts-connection-modal-panel';

export const MODAL_CORNER_RADIUS_PX = 16;

export interface SocialAccountConnectionProps {
  panelId?: string;
  title?: string;
  isOpenedFromEmptyState?: boolean;
}

export const openSocialAccountConnectionModal = (props: SocialAccountConnectionProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_ACCOUNTS_CONNECTION_MODAL,
      panelProps: props,
    })
  );
};
